import { TableFieldModel } from '@/model/TableList'

export const FilterField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerCompanyName',
    fieldName: '客户名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '业务编号'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '业务品牌'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '业务名称'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号'
  },
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'salesManId',
    fieldName: '业务代表',
    options: 'salesManOption',
    focus: 'handleSalesManFocus'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号码'
  },
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceNo',
    fieldName: '发票号码'
  },
  {
    componentType: 'el-select',
    componentName: '输入框',
    fieldKey: 'invoiceStatus',
    fieldName: '开票状态',
    options: 'invoiceStatusOptions'
  }
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'partsCost',
  //   fieldName: '出库成本',
  //   textAlign: 'right',
  //   isMoney: true,
  //   width: 120
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'partsTaxFee',
  //   fieldName: '出库成本税费',
  //   textAlign: 'right',
  //   isMoney: true,
  //   width: 120
  // }
]
